/**
 * Product Search Functionality
 * Client-side filtering of products by title and description
 * Matches React app search logic from App.jsx
 */

class ProductSearch {
  constructor() {
    this.searchInput = document.querySelector('[data-search-input]');
    this.productGrid = document.querySelector('[data-product-grid]');
    this.productCards = null;

    this.init();
  }

  init() {
    if (!this.searchInput || !this.productGrid) {
      console.log('Search elements not found');
      return;
    }

    // Get all product cards
    this.productCards = Array.from(this.productGrid.querySelectorAll('.product-card'));

    // Add input event listener
    this.searchInput.addEventListener('input', this.handleSearch.bind(this));
  }

  handleSearch(e) {
    const searchTerm = e.target.value.toLowerCase().trim();

    if (searchTerm === '') {
      // Show all products when search is empty
      this.productCards.forEach(card => {
        card.style.display = '';
      });
      return;
    }

    // Filter products based on search term
    this.productCards.forEach(card => {
      const title = (card.dataset.productTitle || '').toLowerCase();
      const description = (card.dataset.productDescription || '').toLowerCase();

      // Check if title or description contains search term
      if (title.includes(searchTerm) || description.includes(searchTerm)) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductSearch();
  });
} else {
  new ProductSearch();
}
